module.exports = __webpack_public_path__ + "static/media/bfile-insurance.783bf5a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-insurance.svg
// module id = 571
// module chunks = 0